enum InboundModalId {
  ProductCompliance = "ProductComplianceModal",
  BarcodeConfirm = "InboundProductConfirmModal",
  ShipmentDownloadsModal = "ShipmentDownloadsModal",
}

export default InboundModalId;
